// Tiny WebAudio-generated sound effects — no audio assets needed.
// All calls are safe no-ops if the browser blocks audio (no user gesture yet).

let _ctx = null;
const ctx = () => {
  if (!_ctx) _ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (_ctx.state === 'suspended') _ctx.resume().catch(() => {});
  return _ctx;
};

const tone = (freq, dur = 0.12, delay = 0, type = 'triangle', vol = 0.12) => {
  const c = ctx();
  const t0 = c.currentTime + delay;
  const osc = c.createOscillator();
  const gain = c.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, t0);
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
};

const safe = (fn) => { try { fn(); } catch (_) { /* audio blocked — silent */ } };

// Short pop — preset clicks, small UI confirmations.
export const playPop = () => safe(() => tone(520, 0.07, 0, 'triangle', 0.1));

// Two-note ping — new-launch notifications.
export const playPing = () => safe(() => { tone(880, 0.14, 0, 'sine', 0.08); tone(1318.5, 0.18, 0.06, 'sine', 0.05); });

// Rising 4-note fanfare — successful token launch (plays with the confetti).
export const playLaunchFanfare = () => safe(() => {
  [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => tone(f, 0.2, i * 0.09, 'triangle', 0.13));
});
